<template>
  <q-form ref="form" class="full-width q-pa-md">
    <div class="row items-center">
      <div class="col-12 col-md-6 q-px-sm">
        <q-input
          v-model="formData.prefix"
          label="Application Prefix"
          counter
          :rules="[
            (v) => !!v || 'Application Prefix is required',
            (v) => v.length <= 3 || 'Please use maximum 3 characters',
          ]"
        ></q-input>
      </div>
      <div class="col-12 col-md-6 q-px-sm">
        <q-input
          v-model="formData.name"
          label="Application Name"
          :rules="[(v) => !!v || 'Application Name is required']"
        ></q-input>
      </div>
      <div class="col-12 q-px-sm">
        <q-input
          v-model="formData.hostUrl"
          label="Host Url"
          :rules="[(v) => !!v || 'Application Host Url is required']"
        ></q-input>
      </div>
    </div>
  </q-form>
</template>

<script>
  import { mapGetters } from "vuex";

  export default {
    components: {},
    computed: {
      ...mapGetters({
        currentUser: "auth/currentUser",
        currentUserData: "auth/currentUserData",
      }),
    },
    props: {
      data: {
        type: Object,
        default: null,
      },
    },
    watch: {
      data: function () {
        this.init();
      },
    },
    data: () => ({
      // Extra Data
      formData: {},
    }),
    beforeCreate() {},
    mounted() {
      setTimeout(() => {
        this.init();
      }, 100);
    },
    methods: {
      init() {
        if (this.data != null) {
          this.formData = JSON.parse(JSON.stringify(this.data));
        } else {
          this.formData = {};
        }
      },
      create() {
        this.$emit("loadingStateChanged", true);
        setTimeout(() => {
          this.$refs.form.validate().then((result) => {
            if (result) {
              this.$store
                .dispatch("applications/new", this.formData)
                .then((result) => {
                  this.$emit("loadingStateChanged", false);
                  if (result.Result == "Success") {
                    this.$emit("close", true);
                    this.formData = {};
                    this.$q.notify({
                      position: "top-right",
                      type: "positive",
                      message: result.Response.Message,
                    });
                  } else {
                    this.$q.notify({
                      position: "top-right",
                      type: "negative",
                      message: result.Response.Message,
                    });
                  }
                });
            } else {
              this.$emit("loadingStateChanged", false);
            }
          });
        }, 200);
      },
      save() {
        this.$emit("loadingStateChanged", true);
        setTimeout(() => {
          this.$store
            .dispatch("applications/save", this.formData)
            .then((result) => {
              this.$emit("loadingStateChanged", false);
              if (result.Result == "Success") {
                this.address = "";
                this.$emit("close", true);
                this.$q.notify({
                  position: "top-right",
                  type: "positive",
                  message: result.Response.Message,
                });
              } else {
                this.$q.notify({
                  position: "top-right",
                  type: "negative",
                  message: result.Response.Message,
                });
              }
            });
        });
      },
    },
  };
</script>
